import type { Block } from '../../../../types/proposal-blocks';
import { renderMarkdown } from './markdown';

type Data = Extract<Block, { type: 'callout' }>;

const variantStyles: Record<string, string> = {
  info: 'bg-blue-400/[0.08] border-l-blue-400',
  tip: 'bg-proposal-accent-dim border-l-proposal-accent',
  warning: 'bg-red-500/[0.08] border-l-red-400',
  recommendation: 'bg-proposal-accent-dim border-l-proposal-accent',
};

export function CalloutBlock({ block }: { block: Data }) {
  return (
    <div className={`border-l-[3px] rounded-r-p-md px-4 py-3.5 my-4 text-[13px] text-proposal-fg2 leading-relaxed ${variantStyles[block.variant] || variantStyles.info}`}>
      {block.title && <strong className="text-proposal-fg1 block mb-1">{block.title}</strong>}
      {renderMarkdown(block.body_md)}
    </div>
  );
}
